<template lang="pug">
.card
  .card-header.d-flex.p-0
    ul.nav.nav-pills.mr-auto.p-2
      li.nav-item(v-if="report_type == 'widget'")
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'widget' }", @click="setTabActive('widget')") ウィジェット
      li.nav-item(v-if="report_type == 'pop_up'")
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'pop_up' }", @click="setTabActive('pop_up')") ポップアップ
      li.nav-item(v-if="report_type == 'area_pop_up'")
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'area_pop_up' }", @click="setTabActive('area_pop_up')") ポップアップ
      li.nav-item(v-if="report_type == 'overlay_image'")
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'overlay_image' }", @click="setTabActive('overlay_image')") オーバーレイ
      li.nav-item
        a.nav-link(:class="{ active: $store.state.report.selected_tab == 'creative' }", @click="setTabActive('creative')") クリエイティブ
  .card-body.p-0
    template(v-if="$store.state.report.selected_widget_name")
      .pt-3.pl-3.pb-0
        | 選択中&nbsp;:&nbsp;
        span.tag
          i.fa.fa-times(@click="clearWidget($event)")
          | {{$store.state.report.selected_widget_name}}
    template(v-if="$store.state.report.selected_overlay_name")
      .pt-3.pl-3.pb-0
        | 選択中&nbsp;:&nbsp;
        span.tag
          i.fa.fa-times(@click="clearOverlay($event)")
          | {{$store.state.report.selected_overlay_name}}
    template(v-if="$store.state.report.selected_pop_up_name")
      .pt-3.pl-3.pb-0
        | 選択中&nbsp;:&nbsp;
        span.tag
          i.fa.fa-times(@click="clearPopUp($event)")
          | {{$store.state.report.selected_pop_up_name}}
    .p-3
      form.form-inline
        .form-group
          label 日付&nbsp;:&nbsp;
        .form-group.mr-3
          select.form-control(@change="dateSelectChange")
            option(v-for='date in $store.state.report.date_for_select',:value="date.k",:key="date.k")
              | {{date.v}}
        .form-group
          vuejs-datepicker(:format="DatePickerFormat",:language="language", :value="$store.state.report.date_from", @selected="selectDateFrom", input-class="form-control")
        .form-group &nbsp;~&nbsp;
        .form-group
          vuejs-datepicker(:format="DatePickerFormat",:language="language", :value="$store.state.report.date_to", @selected="selectDateTo", input-class="form-control")
        report-col
    .tab-content
      .tab-pane(:class="{ active: $store.state.report.selected_tab == 'widget' }")
        table.table.table-bordered
          thead
            tr
              th.sort_col(v-for="name in display_col_names")
                template(v-if="name=='widget_name'") {{translateName(name)}}
                template(v-else)
                  template(v-if="ascSorted(name)")
                    span.pointer(@click="sortDescWidgetReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up.active
                    i.fas.fa-sort-down
                  template(v-else-if="descSorted(name)")
                    span.pointer(@click="sortAscWidgetReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down.active
                  template(v-else)
                    span.pointer(@click="sortAscWidgetReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down
          tbody
            tr(v-for="row in $store.state.report.widget_reports")
              td(v-for="name in display_col_names")
                template(v-if='name == "widget_name"')
                  a(href="#",@click="selectWidget(row[name], $event)") {{row[name]}}
                template(v-else)
                  template(v-if="is_loading")
                    div.la-ball-pulse.la-sm
                      div
                      div
                      div
                  template(v-else)
                    | {{modifyNumberFormat(name, row[name])}}
      .tab-pane(:class="{ active: $store.state.report.selected_tab == 'overlay_image' }")
        table.table.table-bordered
          thead
            tr
              th(v-for="name in display_col_names") {{translateName(name)}}
          tbody
            tr(v-for="row in $store.state.report.overlay_reports")
              td(v-for="name in display_col_names")
                template(v-if='name == "overlay_name"')
                  a(href="#",@click="selectOverlay(row[name], $event)") {{row[name]}}
                template(v-else)
                  template(v-if="is_loading")
                    div.la-ball-pulse.la-sm
                      div
                      div
                      div
                  template(v-else)
                    | {{modifyNumberFormat(name, row[name])}}
      .tab-pane(:class="{ active: $store.state.report.selected_tab.match(/pop_up/) }")
        table.table.table-bordered
          thead
            tr
              th.sort_col(v-for="name in display_col_names")
                template(v-if="name=='pop_up_name'") {{translateName(name)}}
                template(v-else)
                  template(v-if="ascSorted(name)")
                    span.pointer(@click="sortDescPopUpReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up.active
                    i.fas.fa-sort-down
                  template(v-else-if="descSorted(name)")
                    span.pointer(@click="sortAscPopUpReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down.active
                  template(v-else)
                    span.pointer(@click="sortAscPopUpReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down
          tbody
            tr(v-for="row in $store.state.report.pop_up_reports")
              td(v-for="name in display_col_names")
                template(v-if='name == "pop_up_name"')
                  a(href="#",@click="selectPopUp(row[name], $event)") {{row[name]}}
                template(v-else)
                  template(v-if="is_loading")
                    div.la-ball-pulse.la-sm
                      div
                      div
                      div
                  template(v-else)
                    | {{modifyNumberFormat(name, row[name])}}
          tbody
            tr(v-for="row in $store.state.report.popup_reports")
              td(v-for="name in display_col_names")
                template(v-if="name == 'popup_name'")
                  a(href="#", @click="selectPopup(row[name], $event)") {{ row[name] }}
                template(v-else)
                  template(v-if="is_loading")
                    div.la-ball-pulse.la-sm
                      div
                      div
                      div
                  template(v-else)
                    | {{ modifyNumberFormat(name, row[name]) }}
      .tab-pane(:class="{ active: $store.state.report.selected_tab == 'creative' }")
        table.table.table-bordered
          thead
            tr
              th.sort_col(v-for="name in display_col_names")
                template(v-if="name=='display' || name=='image' || name=='title'") {{translateName(name)}}
                template(v-else)
                  template(v-if="ascSorted(name)")
                    span.pointer(@click="sortDescCreativeReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up.active
                    i.fas.fa-sort-down
                  template(v-else-if="descSorted(name)")
                    span.pointer(@click="sortAscCreativeReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down.active
                  template(v-else)
                    span.pointer(@click="sortAscCreativeReport(name)") {{translateName(name)}}
                    i.fas.fa-sort-up
                    i.fas.fa-sort-down
          tbody
            tr(v-for="row in $store.state.report.creative_reports")
              td(v-for="name in display_col_names",:class="{ title_wrapper: name=='title' }")
                template(v-if='name == "image"')
                  img(:src='row[name]',width="100px")
                template(v-else-if='name == "display"')
                  toggle-button(:value="row[name]",:labels="true", @change="switchCreative($event, row['url_token'])", :sync="true")
                template(v-else)
                  template(v-if="is_loading")
                    div.la-ball-pulse.la-sm
                      div
                      div
                      div
                  template(v-else)
                    | {{modifyNumberFormat(name, row[name])}}
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

import vuejsDatepicker from 'vuejs-datepicker'

//components
import ReportCol from '../components/reports/cols.vue'

//mixins
import DateformatMixin from '../mixins/date_format.js'

export default {
  props: {
    date_from: String,
    date_to: String,
    date_yesterday_start: String,
    date_yesterday_end: String,
    date_month_start: String,
    date_last_month_start: String,
    date_last_month_end: String,
    report_type: {type: String, default: "widget"}
  },
  data(){
    return {
      DatePickerFormat: 'yyyy-MM-dd',
      language:{
        language: 'Japanese',
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        days: ['日', '月', '火', '水', '木', '金', '土'],
        rtl: false,
        ymd: 'yyyy-MM-dd',
        yearSuffix: '年'
      }
    }
  },
  mixins: [DateformatMixin],
  methods: {
    setTabActive(name){
      this.$store.commit("report/setSelectedTab", name)
      location.hash = name
    },
    getWidgetReport(){
      this.$store.dispatch("report/getWidget")
    },
    getPopUpReport(){
      this.$store.dispatch("report/getPopUp")
    },
    getAreaPopUpReport(){
      this.$store.dispatch("report/getAreaPopUp")
    },
    getOverlayImageReport(){
      this.$store.dispatch("report/getOverlayImage")
    },
    getCreativeReport(){
      this.$store.dispatch("report/getCreative")
    },
    getReport(){
      if(this.$store.state.report.selected_tab=='widget'){
        this.getWidgetReport()
      } else if(this.$store.state.report.selected_tab=='overlay_image'){
        this.getOverlayImageReport()
      } else if(this.$store.state.report.selected_tab=='pop_up'){
        this.getPopUpReport()
      } else if(this.$store.state.report.selected_tab=='area_pop_up'){
        this.getAreaPopUpReport()
      } else if(this.$store.state.report.selected_tab=='creative') {
        this.getCreativeReport()
      }
      this.$store.commit("report/clearSortCol")
    },
    selectWidget(name, e){
      e.preventDefault()
      this.$store.commit("report/setSelectedWidgetName", name)
      this.setTabActive('creative')
    },
    clearWidget(e){
      e.preventDefault()
      this.$store.commit("report/setSelectedWidgetName", '')
    },
    selectPopUp(name, e){
      e.preventDefault()
      this.$store.commit("report/setSelectedPopUpName", name)
      this.setTabActive('creative')
    },
    clearPopUp(e){
      e.preventDefault()
      this.$store.commit("report/setSelectedPopUpName", '')
    },
    selectOverlay(name, e){
      e.preventDefault()
      this.$store.commit("report/setSelectedOverlayName", name)
      this.setTabActive('creative')
    },
    clearOverlay(e){
      e.preventDefault()
      this.$store.commit("report/setSelectedOverlayName", '')
    },
    selectDateFrom(date){
      const date_from = this.formatDateToBegining(date)
      this.$store.commit("report/setDateFrom", date_from)
    },
    selectDateTo(date){
      const date_to = this.formatDateToEnd(date)
      this.$store.commit("report/setDateTo", date_to)
    },
    dateSelectChange(e){
      const date = e.target.value
      if(date == 'today'){
        this.$store.commit("report/setDateFrom", this.date_from)
        this.$store.commit("report/setDateTo", this.date_to)
      } else if(date == 'yesterday'){
        this.$store.commit("report/setDateFrom", this.date_yesterday_start)
        this.$store.commit("report/setDateTo", this.date_yesterday_end)
      } else if(date == 'this_month'){
        this.$store.commit("report/setDateFrom", this.date_month_start)
        this.$store.commit("report/setDateTo", this.date_to)
      } else if(date == 'last_month'){
        this.$store.commit("report/setDateFrom", this.date_last_month_start)
        this.$store.commit("report/setDateTo", this.date_last_month_end)
      }
    },
    modifyNumberFormat(col_name, data){
      if(data === undefined || data === null) {
        return "-"; // dataが未定義またはnullの場合は"-"を返す
      }
      if(col_name == "total_value"){
        return data.toLocaleString() + "円"
      } else if ( col_name == "cpm" ){
        return data.toLocaleString() + "円"
      } else if ( col_name == "imp" ){
        return data.toLocaleString()
      } else if ( col_name == "click" ){
        return data.toLocaleString()
      } else if ( col_name == "ctr" ){
        return data.toLocaleString() + "%"
      } else if ( /count/.test(col_name) ){
        if(col_name == "countdown"){
          return data
        } else {
          return data.toLocaleString()
        }
      } else if ( /value/.test(col_name) ){
        return data.toLocaleString() + "円"
      } else if ( /cvr/.test(col_name) ){
        return data + "%"
      } else {
        return data
      }
    },
    async switchCreative(e, url_token){
      await this.$store.dispatch("report/toggleCreativeDisplay", { url_token: url_token })
      if(e.value){
        this.$toasted.success('配信をONにしました')
        await sleep(10000)
        this.$toasted.clear()
      } else {
        this.$toasted.success('配信をOFFにしました')
        await sleep(10000)
        this.$toasted.clear()
      }
    },
    sortAscWidgetReport(col_name){
      this.$store.commit("report/sortAscWidgetReport", col_name)
      return col_name
    },
    sortDescWidgetReport(col_name){
      this.$store.commit("report/sortDescWidgetReport", col_name)
      return col_name
    },
    sortAscCreativeReport(col_name){
      this.$store.commit("report/sortAscCreativeReport", col_name)
      return col_name
    },
    sortDescCreativeReport(col_name){
      this.$store.commit("report/sortDescCreativeReport", col_name)
      return col_name
    },
    sortAscPopUpReport(col_name){
      this.$store.commit("report/sortAscPopUpReport", col_name)
      return col_name
    },
    sortDescPopUpReport(col_name){
      this.$store.commit("report/sortDescPopUpReport", col_name)
      return col_name
    },
    ascSorted(col_name){
      return this.$store.state.report.sorted_col.name == col_name && this.$store.state.report.sorted_col.mode == "asc"
    },
    descSorted(col_name){
      return this.$store.state.report.sorted_col.name == col_name && this.$store.state.report.sorted_col.mode == "desc"
    },
    translateName(col_name){
      if(col_name == 'widget_name' || col_name == 'pop_up_name' || col_name == 'overlay_name' || col_name == 'popup_name'){
        return "名前"
      } else if(col_name == 'click'){
        return "クリック数"
      } else if(col_name == 'ctr'){
        return "クリック率"
      } else if(col_name == 'imp'){
        return "pv"
      } else if(col_name == 'display_count'){
        return "imp"
      } else if(col_name == 'cv'){
        return "CV数"
      } else if(col_name == 'cvr'){
        return "CV率"
      } else if(col_name == 'image'){
        return "画像"
      } else if(col_name == 'title'){
        return "タイトル"
      } else if(col_name == 'animation'){
        return "アニメーション"
      } else if(col_name == 'arrow'){
        return "矢印表示"
      } else if(col_name == 'display'){
        return "表示"
      } else if(col_name == 'countdown'){
        return "カウントダウン"
      } else if(col_name == 'total_value'){
        return "CV値合計"
      } else if(col_name == 'cpm'){
        return "CPM"
      } else {
        return col_name;
      }
    }
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit("report/setSelectedTab", this.report_type)
    this.$store.commit("report/setReportType", this.report_type)
    this.$store.commit("report/setDateFrom", this.date_from)
    this.$store.commit("report/setDateTo", this.date_to)
    this.$store.dispatch("report/loadCustomColNames")
    window.addEventListener('hashchange', function(e) {
      //console.log('The hash has changed!', location.hash)
      const hash_name = location.hash.replace("#", "")
      if(hash_name != ""){
        this.$store.commit("report/setSelectedTab", hash_name)
      } else {
        this.$store.commit("report/setSelectedTab", this.report_type)
      }
    }.bind(this), false);
  },
  watch: {
    '$store.state.report.selected_tab': function (val) {
      this.getReport()
    },
    '$store.state.report.selected_widget_name': function (val) {
      this.getCreativeReport()
    },
    '$store.state.report.date_from': function (val) {
      this.getReport()
    },
    '$store.state.report.date_to': function (val) {
      this.getReport()
    },
  },
  computed: {
    display_col_names(){
      return this.$store.getters["report/display_col_names"].filter(name => name !== 'display_rate' && name !== 'display_count')
    },
    is_loading(){
      return this.$store.state.report.is_loading
    }
  },
  components: {
    vuejsDatepicker,
    ReportCol
  }
}
</script>
<style lang="scss" scoped>
.tag{
  background: #f5f5f5;
  border: solid 1px #eee;
  padding: 0.2rem 0.5rem;
  font-size: 12px;
  border-radius: 0.2rem;
  .fa{
    margin-right: 0.5rem;
    cursor:pointer;
  }
}
</style>
